// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRemainderDto } from './IRemainderDto';
import {
    IRemainderDtoFromJSON,
    IRemainderDtoFromJSONTyped,
    IRemainderDtoToJSON,
    IRemainderDtoToJSONTyped,
} from './IRemainderDto';
import type { IChildRecordDto } from './IChildRecordDto';
import {
    IChildRecordDtoFromJSON,
    IChildRecordDtoFromJSONTyped,
    IChildRecordDtoToJSON,
    IChildRecordDtoToJSONTyped,
} from './IChildRecordDto';
import type { IOcrLockboxAggregatorDto } from './IOcrLockboxAggregatorDto';
import {
    IOcrLockboxAggregatorDtoFromJSON,
    IOcrLockboxAggregatorDtoFromJSONTyped,
    IOcrLockboxAggregatorDtoToJSON,
    IOcrLockboxAggregatorDtoToJSONTyped,
} from './IOcrLockboxAggregatorDto';
import type { ILockboxEntityMatchDto } from './ILockboxEntityMatchDto';
import {
    ILockboxEntityMatchDtoFromJSON,
    ILockboxEntityMatchDtoFromJSONTyped,
    ILockboxEntityMatchDtoToJSON,
    ILockboxEntityMatchDtoToJSONTyped,
} from './ILockboxEntityMatchDto';
import type { ILockboxDtoDetails } from './ILockboxDtoDetails';
import {
    ILockboxDtoDetailsFromJSON,
    ILockboxDtoDetailsFromJSONTyped,
    ILockboxDtoDetailsToJSON,
    ILockboxDtoDetailsToJSONTyped,
} from './ILockboxDtoDetails';
import type { ICheckDetailsDto } from './ICheckDetailsDto';
import {
    ICheckDetailsDtoFromJSON,
    ICheckDetailsDtoFromJSONTyped,
    ICheckDetailsDtoToJSON,
    ICheckDetailsDtoToJSONTyped,
} from './ICheckDetailsDto';
import type { ILockboxMatchEmployeeAggregatorDto } from './ILockboxMatchEmployeeAggregatorDto';
import {
    ILockboxMatchEmployeeAggregatorDtoFromJSON,
    ILockboxMatchEmployeeAggregatorDtoFromJSONTyped,
    ILockboxMatchEmployeeAggregatorDtoToJSON,
    ILockboxMatchEmployeeAggregatorDtoToJSONTyped,
} from './ILockboxMatchEmployeeAggregatorDto';
import type { IContactDetailsAggregatorDto } from './IContactDetailsAggregatorDto';
import {
    IContactDetailsAggregatorDtoFromJSON,
    IContactDetailsAggregatorDtoFromJSONTyped,
    IContactDetailsAggregatorDtoToJSON,
    IContactDetailsAggregatorDtoToJSONTyped,
} from './IContactDetailsAggregatorDto';
import type { IClaimRepaymentDto } from './IClaimRepaymentDto';
import {
    IClaimRepaymentDtoFromJSON,
    IClaimRepaymentDtoFromJSONTyped,
    IClaimRepaymentDtoToJSON,
    IClaimRepaymentDtoToJSONTyped,
} from './IClaimRepaymentDto';

/**
 * 
 * @export
 * @interface ILockboxDetailsAggregatorDto
 */
export interface ILockboxDetailsAggregatorDto {
    /**
     * 
     * @type {IContactDetailsAggregatorDto}
     * @memberof ILockboxDetailsAggregatorDto
     */
    contact_details?: IContactDetailsAggregatorDto;
    /**
     * 
     * @type {Array<ILockboxMatchEmployeeAggregatorDto>}
     * @memberof ILockboxDetailsAggregatorDto
     */
    match_employees?: Array<ILockboxMatchEmployeeAggregatorDto>;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    organization_name?: string;
    /**
     * 
     * @type {IOcrLockboxAggregatorDto}
     * @memberof ILockboxDetailsAggregatorDto
     */
    ocr?: IOcrLockboxAggregatorDto;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    document_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    form_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    lockbox_type?: ILockboxDetailsAggregatorDtoLockboxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    lockbox_status?: ILockboxDetailsAggregatorDtoLockboxStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    archive_type?: ILockboxDetailsAggregatorDtoArchiveTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ILockboxDetailsAggregatorDto
     */
    liquidate_all_funds?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    birth_date?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    account_number?: string;
    /**
     * 
     * @type {ICheckDetailsDto}
     * @memberof ILockboxDetailsAggregatorDto
     */
    check_details?: ICheckDetailsDto;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    request_date?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILockboxDetailsAggregatorDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {Array<ILockboxEntityMatchDto>}
     * @memberof ILockboxDetailsAggregatorDto
     */
    entity_matches?: Array<ILockboxEntityMatchDto>;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    reason?: ILockboxDetailsAggregatorDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    payment_method_type?: ILockboxDetailsAggregatorDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    wire_status_type?: ILockboxDetailsAggregatorDtoWireStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILockboxDetailsAggregatorDto
     */
    source?: ILockboxDetailsAggregatorDtoSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ILockboxDetailsAggregatorDto
     */
    is_multiple_records?: boolean;
    /**
     * 
     * @type {Array<IChildRecordDto>}
     * @memberof ILockboxDetailsAggregatorDto
     */
    child_records?: Array<IChildRecordDto>;
    /**
     * 
     * @type {number}
     * @memberof ILockboxDetailsAggregatorDto
     */
    parent_id?: number;
    /**
     * 
     * @type {Array<IClaimRepaymentDto>}
     * @memberof ILockboxDetailsAggregatorDto
     */
    claim_repayments?: Array<IClaimRepaymentDto>;
    /**
     * 
     * @type {IRemainderDto}
     * @memberof ILockboxDetailsAggregatorDto
     */
    remainder?: IRemainderDto;
    /**
     * 
     * @type {ILockboxDtoDetails}
     * @memberof ILockboxDetailsAggregatorDto
     */
    details?: ILockboxDtoDetails;
}

/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoLockboxTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INBOUND_TOA = 'INBOUND_TOA',
    OUTBOUND_TOA = 'OUTBOUND_TOA',
    RETURNED_CHECK = 'RETURNED_CHECK',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    BENEFICIARY = 'BENEFICIARY',
    HSA_FORM = 'HSA_FORM',
    MISTAKEN_DISTRIBUTION = 'MISTAKEN_DISTRIBUTION',
    HSA_ROLLOVER_FORM = 'HSA_ROLLOVER_FORM',
    HSA_CONTRIBUTION_FORM = 'HSA_CONTRIBUTION_FORM',
    HSA_TRANSFER_DIVORCE = 'HSA_TRANSFER_DIVORCE',
    HSA_ACCOUNT_CLOSURE = 'HSA_ACCOUNT_CLOSURE',
    COMBINE_HSA = 'COMBINE_HSA',
    DEATH_DISTRIBUTION = 'DEATH_DISTRIBUTION',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    RETURNED_MAIL = 'RETURNED_MAIL',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoLockboxStatusEnum {
    NEW = 'NEW',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    INVESTMENTS_LIQUIDATED = 'INVESTMENTS_LIQUIDATED',
    CANCELED = 'CANCELED',
    DIVIDED = 'DIVIDED',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    PROCESSED_MANUALLY = 'PROCESSED_MANUALLY'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoArchiveTypeEnum {
    PAYMENT = 'PAYMENT',
    NOPAYMENT = 'NOPAYMENT'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoReasonEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE',
    PARTICIPANT_NOT_FOUND = 'PARTICIPANT_NOT_FOUND',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    INVESTMENTS_LIQUIDATION_REQUIRED = 'INVESTMENTS_LIQUIDATION_REQUIRED',
    ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
    OTHER = 'OTHER',
    CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoPaymentMethodTypeEnum {
    CHECK = 'CHECK',
    WIRE = 'WIRE'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoWireStatusTypeEnum {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxDetailsAggregatorDtoSourceEnum {
    UMB = 'UMB',
    DOCUFREE = 'DOCUFREE'
}


/**
 * Check if a given object implements the ILockboxDetailsAggregatorDto interface.
 */
export function instanceOfILockboxDetailsAggregatorDto(value: object): value is ILockboxDetailsAggregatorDto {
    return true;
}

export function ILockboxDetailsAggregatorDtoFromJSON(json: any): ILockboxDetailsAggregatorDto {
    return ILockboxDetailsAggregatorDtoFromJSONTyped(json, false);
}

export function ILockboxDetailsAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxDetailsAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_details': json['contact_details'] == null ? undefined : IContactDetailsAggregatorDtoFromJSON(json['contact_details']),
        'match_employees': json['match_employees'] == null ? undefined : ((json['match_employees'] as Array<any>).map(ILockboxMatchEmployeeAggregatorDtoFromJSON)),
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'ocr': json['ocr'] == null ? undefined : IOcrLockboxAggregatorDtoFromJSON(json['ocr']),
        'id': json['id'] == null ? undefined : json['id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'form_name': json['form_name'] == null ? undefined : json['form_name'],
        'lockbox_type': json['lockbox_type'] == null ? undefined : json['lockbox_type'],
        'lockbox_status': json['lockbox_status'] == null ? undefined : json['lockbox_status'],
        'archive_type': json['archive_type'] == null ? undefined : json['archive_type'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'liquidate_all_funds': json['liquidate_all_funds'] == null ? undefined : json['liquidate_all_funds'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birth_date'] == null ? undefined : json['birth_date'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'check_details': json['check_details'] == null ? undefined : ICheckDetailsDtoFromJSON(json['check_details']),
        'request_date': json['request_date'] == null ? undefined : json['request_date'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'entity_matches': json['entity_matches'] == null ? undefined : ((json['entity_matches'] as Array<any>).map(ILockboxEntityMatchDtoFromJSON)),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'wire_status_type': json['wire_status_type'] == null ? undefined : json['wire_status_type'],
        'source': json['source'] == null ? undefined : json['source'],
        'is_multiple_records': json['is_multiple_records'] == null ? undefined : json['is_multiple_records'],
        'child_records': json['child_records'] == null ? undefined : ((json['child_records'] as Array<any>).map(IChildRecordDtoFromJSON)),
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'claim_repayments': json['claim_repayments'] == null ? undefined : ((json['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoFromJSON)),
        'remainder': json['remainder'] == null ? undefined : IRemainderDtoFromJSON(json['remainder']),
        'details': json['details'] == null ? undefined : ILockboxDtoDetailsFromJSON(json['details']),
    };
}

export function ILockboxDetailsAggregatorDtoToJSON(json: any): ILockboxDetailsAggregatorDto {
    return ILockboxDetailsAggregatorDtoToJSONTyped(json, false);
}

export function ILockboxDetailsAggregatorDtoToJSONTyped(value?: ILockboxDetailsAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_details': IContactDetailsAggregatorDtoToJSON(value['contact_details']),
        'match_employees': value['match_employees'] == null ? undefined : ((value['match_employees'] as Array<any>).map(ILockboxMatchEmployeeAggregatorDtoToJSON)),
        'organization_name': value['organization_name'],
        'ocr': IOcrLockboxAggregatorDtoToJSON(value['ocr']),
        'id': value['id'],
        'document_id': value['document_id'],
        'name': value['name'],
        'form_name': value['form_name'],
        'lockbox_type': value['lockbox_type'],
        'lockbox_status': value['lockbox_status'],
        'archive_type': value['archive_type'],
        'employee_name': value['employee_name'],
        'liquidate_all_funds': value['liquidate_all_funds'],
        'ssn': value['ssn'],
        'birth_date': value['birth_date'],
        'account_id': value['account_id'],
        'amount': value['amount'],
        'contact_id': value['contact_id'],
        'employee_id': value['employee_id'],
        'account_number': value['account_number'],
        'check_details': ICheckDetailsDtoToJSON(value['check_details']),
        'request_date': value['request_date'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'entity_matches': value['entity_matches'] == null ? undefined : ((value['entity_matches'] as Array<any>).map(ILockboxEntityMatchDtoToJSON)),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'invoice_id': value['invoice_id'],
        'check_id': value['check_id'],
        'reason': value['reason'],
        'notes': value['notes'],
        'payment_method_type': value['payment_method_type'],
        'wire_status_type': value['wire_status_type'],
        'source': value['source'],
        'is_multiple_records': value['is_multiple_records'],
        'child_records': value['child_records'] == null ? undefined : ((value['child_records'] as Array<any>).map(IChildRecordDtoToJSON)),
        'parent_id': value['parent_id'],
        'claim_repayments': value['claim_repayments'] == null ? undefined : ((value['claim_repayments'] as Array<any>).map(IClaimRepaymentDtoToJSON)),
        'remainder': IRemainderDtoToJSON(value['remainder']),
        'details': ILockboxDtoDetailsToJSON(value['details']),
    };
}

